<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !slbWarningForm.id
          ? this.$t('alarms.network.loadBalancing.addLBAlarm')
          : this.$t('alarms.network.loadBalancing.editLBAlarm')
      "
      @on-cancel="cancel"
      @on-ok="ok"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="1000px"
      :footer-hide="true"
      :closable="false"
    >
      <Form
        ref="slbWarningForm"
        :model="slbWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning
            v-if="wechatWarningVisible"
            ref="wechatWarning"
          ></wechat-warning>
          <!-- 规则名称 -->
          <FormItem
            :label="$t('alarms.common.ruleName')"
            prop="ruleName"
            v-if="isEditRuleName"
          >
            <Row>
              <Col span="11">
                <Input
                  type="text"
                  v-model="slbWarningForm.ruleName"
                  placeholder="Enter something..."
                  style="width: 300px"
                  :disabled="isEdit"
                ></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{ this.slbWarningForm.ruleName }}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select
                    v-model="slbWarningForm.monitorIndex"
                    filterable
                    @on-change="changeMonitorIndex(slbWarningForm.monitorIndex)"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in monitorIndexList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select
                    v-model="slbWarningForm.cycle"
                    filterable
                    :placeholder="$t('alarms.common.cycle')"
                    @on-change="changeCycle(slbWarningForm.cycle)"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in cycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select
                    v-model="slbWarningForm.continousCycle"
                    filterable
                    :placeholder="$t('alarms.common.continuousCycle')"
                    @on-change="
                      changeContinousCycle(slbWarningForm.continousCycle)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in continousCycleList"
                      v-bind:key="index"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select
                    v-model="slbWarningForm.statisticsValue"
                    filterable
                    :placeholder="$t('alarms.common.statisticsValue')"
                    @on-change="
                      changeStatisticsValue(slbWarningForm.statisticsValue)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in statisticsValueList"
                      v-bind:key="index"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>

              <!-- 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位 -->
              <div v-if="this.isShowField != 1">
                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select
                      v-model="slbWarningForm.relationshipSign"
                      filterable
                      @on-change="
                        changeRelationshipSign(slbWarningForm.relationshipSign)
                      "
                      :placeholder="$t('alarms.common.symbol')"
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in relationshipSignList"
                        v-bind:key="index"
                      >{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input
                      v-model="slbWarningForm.thresholdValue"
                      :placeholder="$t('alarms.common.threshold')"
                      type="number"
                    ></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input
                      v-model="slbWarningForm.unit"
                      disabled
                      :placeholder="$t('alarms.common.unit')"
                    ></Input>
                  </FormItem>
                </Col>
              </div>
              <div v-else-if="this.isShowField == 2">
                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select
                      v-model="slbWarningForm.relationshipSign"
                      filterable
                      @on-change="
                        changeRelationshipSign(slbWarningForm.relationshipSign)
                      "
                      :placeholder="$t('alarms.common.symbol')"
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in relationshipSignList"
                        v-bind:key="index"
                      >{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input
                      v-model="slbWarningForm.thresholdValue"
                      :placeholder="$t('alarms.common.threshold')"
                      type="number"
                    ></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input
                      v-model="slbWarningForm.unit"
                      disabled
                      :placeholder="$t('alarms.common.unit')"
                    ></Input>
                  </FormItem>
                </Col>
              </div>
            </Row>
          </FormItem>

          <!-- 审批流 -->
          <FormItem
            :label="$t('alarms.common.approvalFlow')"
            prop="approvalFlow"
            v-if="slbWarningForm.monitorIndex == 35"
          >
            <Select
              v-model="slbWarningForm.approvalFlow"
              filterable
              style="width: 300px"
              :transfer="true"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                :value="item.id"
                v-for="(item, index) in approvalFlowList"
                v-bind:key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
            <RadioGroup
              v-model="slbWarningForm.contactType"
              @on-change="changeContactType(slbWarningForm.contactType)"
            >
              <Radio
                v-for="item in contactTypeList"
                :label="item.type"
                :key="item.value"
                >{{ item.label }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem
            :label="$t('alarms.common.notificationObject')"
            prop="notificationObject"
            v-if="slbWarningForm.contactType == 0"
          >
            <Select
              v-model="slbWarningForm.notificationObject"
              filterable
              multiple
              style="width: 300px"
              @on-change="changeNotificationObject"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in notificationObjectList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem
            :label="$t('alarms.common.contactGroup')"
            prop="contactGroupIds"
            v-if="slbWarningForm.contactType == 1"
          >
            <Select
              v-model="slbWarningForm.contactGroupIds"
              filterable
              multiple
              style="width: 300px"
              @on-change="changeContactGroupId(slbWarningForm.contactGroupIds)"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in contactGroupIdList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select
              v-model="slbWarningForm.noticeType"
              filterable
              multiple
              style="width: 300px"
              @on-change="selectnoticeType(slbWarningForm.noticeType)"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmWayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem
            :label="$t('alarms.common.enterpriseWeChatRobotURL')"
            prop="enterpriseWechatRobotIds"
            v-if="
              slbWarningForm.noticeType.filter(function (e) {
                return e == 3;
              }).length != 0
            "
          >
            <Select
              v-model="slbWarningForm.enterpriseWechatRobotIds"
              filterable
              multiple
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in enterpriseWechatRobotIdsList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select
              v-model="slbWarningForm.alarmDelay"
              filterable
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmDelayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem
            :label="$t('alarms.common.monitorPeriod')"
            prop="monitorPeriod"
          >
            <Select
              v-model="slbWarningForm.monitorPeriod"
              filterable
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in monitorPeriodList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input
                v-model="slbWarningForm.emailModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem
              :label="$t('alarms.common.wechatModal')"
              prop="wechatModal"
            >
              <Input
                v-model="slbWarningForm.wechatModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              style="float: right"
              @click="ok('slbWarningForm')"
              :loading="addloading"
              :disabled="isAddOrEdit"
            >
              {{
                !slbWarningForm.id
                  ? this.$t("common.addAlarm")
                  : this.$t("common.editAlarm")
              }}
            </Button>
            <Button
              size="large"
              style="float: right; margin-right: 10px"
              @click="cancel('slbWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
            <Button
              size="large"
              @click="previousPage"
              style="float: right; margin-right: 10px"
              >{{ $t("alarms.common.lastStep") }}</Button
            >
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="7">
                <!-- 账户 -->
                <FormItem
                  :label="$t('alarms.common.account')"
                  prop="account"
                  :label-width="70"
                >
                  <Select
                    v-model="slbWarningForm.account"
                    filterable
                    @on-change="changeAccount(slbWarningForm.account)"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in accountList"
                      v-bind:key="index"
                      >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="7">
                <!-- 存储区域 -->
                <FormItem
                  :label="$t('alarms.common.region')"
                  prop="backupRegion"
                >
                  <Select
                    @on-change="changebackupRegion(slbWarningForm.backupRegion)"
                    v-model="slbWarningForm.backupRegion"
                    filterable
                    multiple
                    :max-tag-count="1"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Checkbox
                      v-model="singleBackupRegion"
                      @on-change="selectBackupRegionAll"
                      style="display: block; text-align: right"
                      >{{ $t("alarms.common.allSelected") }}</Checkbox
                    >
                    <Option
                      :value="item.name"
                      v-for="item in backupRegionList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="7">
                <!-- 负载均衡类型 -->
                <FormItem
                  :label="$t('alarms.network.loadBalancing.LBType')"
                  prop="loadbalancerType"
                >
                  <Select
                    v-model="slbWarningForm.loadbalancerType"
                    filterable
                    :transfer="true"
                    @on-change="
                      changeLoadbalancerType(slbWarningForm.loadbalancerType)
                    "
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.name"
                      v-for="(item, index) in loadbalancerTypeList"
                      :key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Button
                type="primary"
                style="float: right"
                v-show="isShowSearch"
                @click="searchSLBDate"
                >{{ $t("alarms.common.search") }}</Button
              >
            </Row>
          </div>

          <v-table
            :height="459"
            column-width-drag
            is-horizontal-resize
            style="width: 100%; height: 459px; margin-bottom: 15px"
            :columns="column"
            :table-data="tableSlbDate"
            row-hover-color="#edf7ff"
            :is-loading="modal_loadings"
            title-bg-color="#f8f8f9"
            :select-group-change="selectChange"
            :select-all="selectAll"
          ></v-table>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              @click="nextPage"
              style="float: right"
              :disabled="isNextClick"
              >{{ $t("alarms.common.nextStep") }}
            </Button>
            <Button
              size="large"
              style="margin-right: 10px; float: right"
              @click="cancel('slbWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import WechatWarning from "../../common/WechatWarning.vue";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableSlb from "../slb/TableSlb.vue";

var tableSlb = TableSlb;
var tableSlbWarningVue = {};
export default {
  inject: ["reload"],
  components: {
    WechatWarning,
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.alertRule
        .nameRepeatedCheck({
          alertRuleName: this.slbWarningForm.ruleName,
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            callback(new Error("规则名称不能重复!"));
          }
        });
    };
    return {
      accountType: "",
      monitorModule: "",
      isAddOrEdit: true,
      wechatWarningVisible: false,
      contactTypeList: [
        {
          label: this.$t("alarms.common.contactPerson"),
          value: "contact",
          type: 0,
        },
        {
          label: this.$t("alarms.common.contactGroup"),
          value: "contactGroup",
          type: 1,
        },
      ],

      accountList: [],
      loadbalancerTypeList: [],
      addloading: false,
      singleBackupRegion: false,
      alarmDelayList: [],
      monitorPeriodList: [],
      isEdit: false,
      isShowSearch: false,
      isEditRuleName: false,
      showRuleName: false,
      modal_loadings: false,
      isShowField: "", //是否显示符号、阈值和单位
      isShowEmail: false,
      isShowWeChat: false,
      isNext: false,
      isPrevious: true,
      selection: [],
      notificationObjectList: [],
      alarmWayList: [],
      backupRegionList: [],
      loading: true,
      modal: false,
      modal_loading: false,
      exportDataList: "",
      noticeType: [],
      units: "",
      isNextClick: true, //禁止点击下一步
      unit: "",
      approvalFlowList: [],
      slbWarningForm: {
        account: "",
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        thresholdValue: 0,
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        relationshipSign: "",
        unit: "",
        backupRegion: [],
        alarmDelay: "",
        monitorPeriod: "",
        contactType: 0,
        contactGroupIds: [],
        loadbalancerType: "",
        userIdList: [],
        approvalFlow: "",
        enterpriseWechatRobotIds: [],
      },
      enterpriseWechatRobotIdsList: [],
      // 联系人组
      contactGroupIdList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        account: [
          {
            required: true,
            message: "请选择账户名称",
            trigger: "change",
            type: "number",
          },
        ],
        alarmDelay: [
          {
            required: true,
            message: "请选择延迟告警",
            trigger: "change",
            type: "number",
          },
        ],
        monitorPeriod: [
          {
            required: true,
            message: "请选择监控时段",
            trigger: "change",
            type: "number",
          },
        ],
        backupRegion: [
          {
            required: true,
            type: "array",
            message: "请选择存储区域",
            trigger: "change",
          },
        ],
        ruleName: [
          { required: true, message: "规则名称不能为空", trigger: "blur" },
          {
            type: "string",
            message: "规则名称为2-20个字符首尾中间不能有空格",
            pattern: "^[^ ]{2,20}$",
            trigger: "blur",
          },
          { validator: validNameRepeatedCheck, trigger: "blur" },
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: "请选择通知对象",
            trigger: "change",
          },
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择报警方式",
            trigger: "change",
          },
        ],
        monitorIndex: [
          {
            required: true,
            message: "请选择监控指标",
            trigger: "change",
            type: "number",
          },
        ],
        cycle: [
          {
            required: true,
            message: "请选择周期",
            trigger: "change",
            type: "number",
          },
        ],
        continousCycle: [
          {
            required: true,
            message: "请选择连续周期",
            trigger: "change",
            type: "number",
          },
        ],
        statisticsValue: [
          {
            required: true,
            message: "请选择统计数值",
            trigger: "change",
            type: "number",
          },
        ],
        relationshipSign: [
          {
            required: true,
            message: "请选择关系符号",
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValue: [{ required: true, message: "请输入阈值" }],
        contactType: [
          {
            required: true,
            message: "请选择联系方式",
            trigger: "change",
            type: "number",
          },
        ],
        contactGroupIds: [
          {
            required: true,
            message: "请选择联系人组",
            trigger: "change",
            type: "array",
          },
        ],
        approvalFlow: [
          {
            required: true,
            message: "请选择审批流",
            trigger: "change",
            type: "number",
          },
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: "请选择企业微信机器人URL",
            trigger: "change",
          },
        ],
      },
      column: [
        {
          width: 60,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection",
        },
        {
          field: "name",
          title: this.$t("alarms.network.loadBalancing.name"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "stateName",
          title: this.$t("alarms.network.loadBalancing.status"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "dnsName",
          title: this.$t("alarms.network.loadBalancing.DNSName"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "vpcId",
          title: this.$t("alarms.network.loadBalancing.vpcId"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "loadbalancerType",
          title: this.$t("alarms.network.loadBalancing.LBType"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
      ],
      tableSlbDate: [],
      newTableSlbDateList: [],
      loadBalancerList: [],
      compareLoadBalancerList: [],
    };
  },

  beforeCreate: function () {
    tableSlbWarningVue = this;
  },
  methods: {
    // 下一步
    nextPage: function () {
      this.isNext = true;
      this.isPrevious = false;
      // 查询监控指标
      tableSlbWarningVue.searchMonitorIndex();
      // 查询阈值
      tableSlbWarningVue.selectMonitorIndexDefault();
      // 监控模块查询关联的机器人列表
      tableSlbWarningVue.listEnterpriseWechatRobotsByMonitorModule();
      // 查询联系人组
      tableSlbWarningVue.listContactGroups();
    },
    // 上一步
    previousPage: function () {
      this.isNext = false;
      this.isPrevious = true;
    },
    init: function (id) {
      this.slbWarningForm.id = id || 0;
      // 根据用户名查询Account列表
      tableSlbWarningVue.getAccount();
      this.$nextTick(() => {
        // 重置表单
        this.$refs["slbWarningForm"].resetFields();
        // 编辑
        if (this.slbWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;
          this.isShowSearch = false;
          this.$api.alertRule
            .selectAlertRule("id", this.slbWarningForm.id)
            .then((res) => {
              // 存储区域
              const regions = res.data.regions;
              tableSlbWarningVue.$api.account
                .queryAccountRegions("accountId", res.data.accountId)
                .then((res) => {
                  this.backupRegionList = res.data;
                  this.slbWarningForm.backupRegion = regions;
                });

              // 根据账号类型查询负载类型列表
              const loadbalancerType = res.data.loadbalancerType;
              setTimeout(() => {
                tableSlbWarningVue.$api.account
                  .listLoadBalancerTypes("accountType", res.data.accountType)
                  .then((res) => {
                    this.loadbalancerTypeList = res.data;
                    this.slbWarningForm.loadbalancerType = loadbalancerType;
                    this.searchChange();
                  });
              }, 1000);

              //延时
              this.slbWarningForm.alarmDelay = res.data.delay;
              //监控时段
              this.slbWarningForm.monitorPeriod = res.data.monitorPeriod;
              // 账户
              this.slbWarningForm.account = res.data.accountId;
              // 账户类型
              this.slbWarningForm.accountType = res.data.accountType;
              this.accountType = res.data.accountType;
              //monitorModule
              this.monitorModule = res.data.monitorModule;
              /******************************************************/

              /******************************************************/
              setTimeout(() => {
                tableSlbWarningVue.$api.contact
                  .queryContactsByAccountIdAndMonitorModule({
                    monitorModule: this.monitorModule,
                    accountId: this.slbWarningForm.account,
                  })
                  .then((res) => {
                    this.notificationObjectList = res.data.contactList;
                  });
              }, 1000);

              this.modal_loadings = true;
              // 实例列表
              /******************************************************/
              this.loadBalancerList = res.data.loadBalancerList;
              this.compareLoadBalancerList = res.data.loadBalancerList;
              setTimeout(() => {
                if (
                  this.slbWarningForm.loadbalancerType &&
                  this.slbWarningForm.backupRegion
                ) {
                  // 根据AccountId查询loadBalancer列表
                  tableSlbWarningVue.$api.loadBalancer
                    .queryLoadBalancerListByAccount({
                      monitorModule: this.monitorModule,
                      regions: this.slbWarningForm.backupRegion,
                      accountId: this.slbWarningForm.account,
                      loadbalancerType: this.slbWarningForm.loadbalancerType,
                      accountType: res.data.accountType,
                    })
                    .then((res) => {
                      this.tableSlbDate = res.data;
                      this.modal_loadings = false;
                      for (var i = 0; i < this.tableSlbDate.length; i++) {
                        for (
                          var j = 0;
                          j < this.compareLoadBalancerList.length;
                          j++
                        ) {
                          if (
                            this.tableSlbDate[i].id ==
                            this.compareLoadBalancerList[j].id
                          ) {
                            this.tableSlbDate[i]._checked = true;
                          }
                        }
                      }
                      // 选了数据 可以点击下一步
                      if (
                        this.tableSlbDate.length == 0 ||
                        this.compareLoadBalancerList.length == 0
                      ) {
                        this.isNextClick = true;
                      } else {
                        this.isNextClick = false;
                      }
                    });
                }
              }, 2000);

              this.newTableSlbDateList = res.data.loadBalancerList;

              // 规则名称
              this.slbWarningForm.ruleName = res.data.alertRuleName;
              // 企业微信机器人URL
              this.slbWarningForm.enterpriseWechatRobotIds =
                res.data.enterpriseWechatRobotIds;

              // 监控指标
              /******************************************************/
              this.slbWarningForm.monitorIndex = res.data.monitorIndex;
              // 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位
              if (
                this.slbWarningForm.monitorIndex == 7 ||
                this.slbWarningForm.monitorIndex == 8 ||
                this.slbWarningForm.monitorIndex == 10 ||
                this.slbWarningForm.monitorIndex == 56
              ) {
                this.isShowField = 1;
              } else {
                this.isShowField = 2;
              }

              // get company id
              tableSlbWarningVue.$api.account
                .getCompanyIdByAccountId(
                  "accountId",
                  this.slbWarningForm.account
                )
                .then((res) => {
                  let companyId = res.data;
                  // 审批流
                  tableSlbWarningVue.$api.processTemplate
                    .listProcessTemplatesByMetricIndexAndCompanyId({
                      metricIndex: this.slbWarningForm.monitorIndex,
                      companyId: companyId,
                    })
                    .then((res) => {
                      this.approvalFlowList = res.data;
                    });
                });

              this.slbWarningForm.approvalFlow = parseInt(
                res.data.processTemplateId
              );

              // 周期
              this.slbWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.slbWarningForm.continousCycle = res.data.continousCycle;
              // 统计数值
              this.slbWarningForm.statisticsValue = res.data.statisticsValue;
              // 符号
              this.slbWarningForm.relationshipSign = res.data.relationshipSign;
              // 阈值
              this.slbWarningForm.thresholdValue = res.data.thresholdValue;
              // 单位
              this.slbWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;

              // 联系方式
              this.slbWarningForm.contactType = res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.notificationObjectList = res.data.contactDTOList;
                this.slbWarningForm.notificationObject = res.data.contactIDs;
                for (
                  var i = 0;
                  i < this.slbWarningForm.notificationObject.length;
                  i++
                ) {
                  for (var j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.slbWarningForm.notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.slbWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup
                  .listContactGroupsByAccountId(
                    "accountId",
                    this.slbWarningForm.account
                  )
                  .then((res) => {
                    this.contactGroupIdList = res.data;
                  });
                setTimeout(() => {
                  this.slbWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }

              // 报警方式
              this.slbWarningForm.noticeType = res.data.noticeType;

              for (var i = 0; i < this.slbWarningForm.noticeType.length; i++) {
                if (this.slbWarningForm.noticeType[i] == "0") {
                  this.isShowEmail = true;
                  this.slbWarningForm.emailModal = res.data.briefReportBodyMail;
                  this.noticeType = this.slbWarningForm.noticeType;
                  tableSlbWarningVue.selectTemplate();
                }
                if (this.slbWarningForm.noticeType[i] == "1") {
                  // this.isShowWeChat = true;
                  this.slbWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType = this.slbWarningForm.noticeType;
                  tableSlbWarningVue.selectTemplate();
                } else if (this.slbWarningForm.noticeType[i] != "1") {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
            });
        } else {
          this.tableSlbDate = [];
          this.isEdit = false;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.showRuleName = false;
        }
      });
      this.modal = true;
      this.isNext = false;
      this.isPrevious = true;
    },
    // 根据监控指标 显示不同单位
    /****************************************************************/
    // 清空周期、连续周期、统计数值、关系符号
    emptyDate: function () {
      this.slbWarningForm.cycle = "";
      this.slbWarningForm.continousCycle = "";
      this.slbWarningForm.statisticsValue = "";
      this.slbWarningForm.relationshipSign = "";
      this.slbWarningForm.thresholdValue = "";
    },
    isNotEmpty: function (obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function () {
      // 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位
      if (
        this.slbWarningForm.monitorIndex == 7 ||
        this.slbWarningForm.monitorIndex == 8 ||
        this.slbWarningForm.monitorIndex == 10 ||
        this.slbWarningForm.monitorIndex == 56
      ) {
        this.isShowField = 1;
      } else {
        this.isShowField = 2;
      }
      tableSlbWarningVue.selectMonitorIndexDefault();
      this.unit = this.slbWarningForm.monitorIndex;
      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.unit) {
          this.slbWarningForm.unit = this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableSlbWarningVue.selectTemplate();
      tableSlbWarningVue.emptyDate();
      tableSlbWarningVue.listProcessTemplatesByMetricIndex();
    },
    // 查询审批流列表
    listProcessTemplatesByMetricIndex: function () {
      if (this.slbWarningForm.monitorIndex == undefined) {
        return;
      }

      tableSlbWarningVue.$api.account
        .getCompanyIdByAccountId("accountId", this.slbWarningForm.account)
        .then((res) => {
          let companyId = res.data;
          // 审批流
          tableSlbWarningVue.$api.processTemplate
            .listProcessTemplatesByMetricIndexAndCompanyId({
              metricIndex: this.slbWarningForm.monitorIndex,
              companyId: companyId,
            })
            .then((res) => {
              this.approvalFlowList = res.data;
            });
        });
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function () {
      if (
        this.slbWarningForm.account == "" ||
        this.slbWarningForm.account == null
      ) {
        return;
      }
      tableSlbWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorIndex: this.slbWarningForm.monitorIndex,
          monitorModule: this.monitorModule,
          cycle: this.slbWarningForm.cycle,
          continousCycle: this.slbWarningForm.continousCycle,
          statisticsValue: this.slbWarningForm.statisticsValue,
          relationshipSign: this.slbWarningForm.relationshipSign,
          accountId: this.slbWarningForm.account,
        })
        .then((res) => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableSlbWarningVue.isNotEmpty(this.slbWarningForm.cycle) &&
            tableSlbWarningVue.isNotEmpty(this.slbWarningForm.continousCycle) &&
            tableSlbWarningVue.isNotEmpty(
              this.slbWarningForm.statisticsValue
            ) &&
            tableSlbWarningVue.isNotEmpty(
              this.slbWarningForm.relationshipSign
            ) &&
            this.slbWarningForm.id == 0
          ) {
            this.slbWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate: function () {
      tableSlbWarningVue.$api.briefReport
        .selectTemplate({
          monitorIndex: this.slbWarningForm.monitorIndex,
          relationshipSign: this.slbWarningForm.relationshipSign,
          monitorModule: this.monitorModule,
          noticeType: this.slbWarningForm.noticeType,
        })
        .then((res) => {
          this.slbWarningForm.wechatModal = res.data.briefReportBodyWechat;
          this.slbWarningForm.emailModal = res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectnoticeType: function () {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (var i = 0; i < this.slbWarningForm.noticeType.length; i++) {
        if (this.slbWarningForm.noticeType[i] == "0") {
          this.isShowEmail = true;
          this.noticeType = this.slbWarningForm.noticeType;
          tableSlbWarningVue.selectTemplate();
        }
        if (this.slbWarningForm.noticeType[i] == "1") {
          // this.isShowWeChat = true;
          this.noticeType = this.slbWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableSlbWarningVue.selectTemplate();
        } else if (this.slbWarningForm.noticeType[i] != "1") {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat: function () {
      for (var i = 0; i < this.slbWarningForm.noticeType.length; i++) {
        if (this.slbWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.slbWarningForm.contactType,
          };
          // 联系方式为 -联系人-
          if (this.slbWarningForm.contactType == 0) {
            weChatDate.userIds = this.slbWarningForm.userIdList;
          }
          // 联系方式为 -联系人组-
          else if (this.slbWarningForm.contactType == 1) {
            weChatDate.contactGroupIds = this.slbWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then((res) => {
              if (res.data) {
                // 可以添加告警
                this.wechatWarningVisible = false;
                this.isAddOrEdit = false;
              } else {
                // 不可以添加微信告警
                this.wechatWarningVisible = true;
                this.isAddOrEdit = true;
              }
            });
        } else if (this.slbWarningForm.noticeType[i] != 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups: function () {
      this.$api.contactGroup
        .listContactGroupsByAccountId("accountId", this.slbWarningForm.account)
        .then((res) => {
          this.contactGroupIdList = res.data;
        });
    },
    // 切换联系人组
    changeContactGroupId: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换通知对象
    changeNotificationObject: function (val) {
      this.slbWarningForm.userIdList = [];
      this.slbWarningForm.notificationObject = val;
      for (var i = 0; i < this.slbWarningForm.notificationObject.length; i++) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.slbWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.slbWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换联系方式
    changeContactType: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    //点击查询 加载全部数据
    /***********************************************************************************/
    searchSLBDate: function () {
      if (
        this.slbWarningForm.account == "" ||
        this.slbWarningForm.account == null ||
        this.slbWarningForm.backupRegion == "" ||
        this.slbWarningForm.backupRegion == null
      ) {
        return;
      }
      this.modal_loadings = true;
      // 根据AccountId查询loadBalancer列表
      tableSlbWarningVue.$api.loadBalancer
        .queryLoadBalancerListByAccount({
          regions: this.slbWarningForm.backupRegion,
          accountId: this.slbWarningForm.account,
          loadbalancerType: this.slbWarningForm.loadbalancerType,
          accountType: this.accountType,
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          this.tableSlbDate = res.data;
          this.modal_loadings = false;
        });
    },

    /**************************************  查询  **************************************/
    // 查询监控指标
    searchMonitorIndex: function () {
      tableSlbWarningVue.$api.alertRule
        .searchMonitorIndex({
          monitorModule: this.monitorModule,
          accountId: this.slbWarningForm.account,
        })
        .then((res) => {
          this.monitorIndexList = res.data;
        });
    },
    // 查询通知对象
    queryContacts: function () {
      tableSlbWarningVue.$api.contact
        .queryContactsByAccountIdAndMonitorModule({
          monitorModule: this.monitorModule,
          accountId: this.slbWarningForm.account,
        })
        .then((res) => {
          this.notificationObjectList = res.data.contactList;
          this.slbWarningForm.notificationObject = res.data.defaultContactIds;
        });
    },
    // 查询报警方式
    alarmWay: function () {
      tableSlbWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmWayList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay: function () {
      tableSlbWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmDelayList = res.data;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod: function () {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then((res) => {
          this.monitorPeriodList = res.data;
        });
    },
    // 周期
    changeCycle: function () {
      // 查询阈值
      tableSlbWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function () {
      // 查询阈值
      tableSlbWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function () {
      // 查询阈值
      tableSlbWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function () {
      // 查询阈值
      tableSlbWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableSlbWarningVue.selectTemplate();
    },
    // 根据用户名查询Account列表
    getAccount: function () {
      // 清空表格
      this.tableSlbDate = [];
      tableSlbWarningVue.$api.account
        .queryAccounts("userName", getCookie(global.cookieName))
        .then((res) => {
          this.accountList = res.data;
          for (var i = 0; i < this.accountList.length; i++) {
            this.accountList[i].name =
              this.accountList[i].name +
              "(" +
              this.accountList[i].accountTypeName +
              ")";
          }
        });
      // 查询方式
      tableSlbWarningVue.alarmWay();
      // 查询报警延时
      tableSlbWarningVue.getAlarmDelay();
      //监控时段
      tableSlbWarningVue.searchMonitorPeriod();
    },
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule: function () {
      tableSlbWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule({
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    // 选择账户
    changeAccount: function () {
      this.searchChange();
      if (
        this.slbWarningForm.account == "" ||
        this.slbWarningForm.account == null
      ) {
        return;
      }
      this.slbWarningForm.backupRegion = "";
      this.slbWarningForm.loadbalancerType = "";
      // 清空表格
      this.tableSlbDate = [];
      this.loadBalancerList = [];
      this.isNextClick = true;
      tableSlbWarningVue.$api.account
        .queryAccountRegions("accountId", this.slbWarningForm.account)
        .then((res) => {
          this.backupRegionList = res.data;
        });
      //根据账户ID查询账户类型
      tableSlbWarningVue.$api.account
        .getAccountTypeByAccountId("id", this.slbWarningForm.account)
        .then((res) => {
          this.accountType = res.data;
          //根据账号查询负载均衡类型
          tableSlbWarningVue.$api.account
            .listLoadBalancerTypes("accountType", this.accountType)
            .then((res) => {
              this.loadbalancerTypeList = res.data;
            });
        });

      // 查询联系人组
      tableSlbWarningVue.listContactGroups();
    },
    // 何时显示查询按钮
    searchChange: function () {
      if (
        this.slbWarningForm.account &&
        this.slbWarningForm.backupRegion &&
        this.slbWarningForm.loadbalancerType
      ) {
        this.isShowSearch = true;
      } else {
        this.isShowSearch = false;
      }
    },
    /***********存储区域**************************/
    selectBackupRegionAll() {
      this.slbWarningForm.backupRegion = [];
      if (this.singleBackupRegion) {
        this.backupRegionList.map((item) => {
          this.slbWarningForm.backupRegion.push(item.name);
        });
      } else {
        this.slbWarningForm.backupRegion = [];
      }
    },
    // 切换存储区域
    changebackupRegion: function (val) {
      if (val.length === this.backupRegionList.length && val.length != 0) {
        this.singleBackupRegion = true;
      } else {
        this.singleBackupRegion = false;
      }
      // 表格数据为空、显示查询按钮、存储区域为空
      this.searchChange();
      this.slbWarningForm.loadbalancerType = "";
      this.tableSlbDate = [];
      this.loadBalancerList = [];
      this.isNextClick = true;
    },
    // 切换负载均衡类型
    changeLoadbalancerType: function () {
      if (this.accountType == 0) {
        if ("CLB" == this.slbWarningForm.loadbalancerType) {
          this.monitorModule = 6;
        } else if (
          "ALB" == this.slbWarningForm.loadbalancerType ||
          "NLB" == this.slbWarningForm.loadbalancerType ||
          "GLB" == this.slbWarningForm.loadbalancerType
        ) {
          this.monitorModule = 27;
        }
      } else if (this.accountType == 1) {
        if ("ALB" == this.slbWarningForm.loadbalancerType) {
          this.monitorModule = 38;
        } else if ("SLB" == this.slbWarningForm.loadbalancerType) {
          this.monitorModule = 21;
        }
      }else if (this.accountType == 4){
        if ("HTTP(S)" == this.slbWarningForm.loadbalancerType){
          this.monitorModule = 41
        }else if ("TCP" == this.slbWarningForm.loadbalancerType){
          this.monitorModule = 42
        }else if ("UDP" == this.slbWarningForm.loadbalancerType) {
          this.monitorModule = 43
        }
      }

      this.searchChange();
      this.tableSlbDate = [];
      this.loadBalancerList = [];
      this.isNextClick = true;
      if (this.slbWarningForm.loadbalancerType == undefined) {
        return;
      }
      this.queryContacts();
    },
    // 全选 单选
    /***********************************************************************************/
    // 单选
    selectChange(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableSlbDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableSLBCopy = new Object();
        TableSLBCopy.id = this.selection[i].id;
        TableSLBCopy.name = this.selection[i].name;
        TableSLBCopy.dnsName = this.selection[i].dnsName;
        TableSLBCopy.state = this.selection[i].state;
        TableSLBCopy.vpcId = this.selection[i].vpcId;
        TableSLBCopy.loadbalancerType = this.selection[i].loadbalancerType;
        TableSLBCopy.region = this.selection[i].region;
        TableSLBCopy.loadBalancerArn = this.selection[i].loadBalancerArn;
        this.newTableSlbDateList.push(TableSLBCopy);
      }
      // 选了数据 可以点击下一步
      if (this.newTableSlbDateList.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 全选
    selectAll: function (selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableSlbDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableSLBCopy = new Object();
        TableSLBCopy.id = this.selection[i].id;
        TableSLBCopy.name = this.selection[i].name;
        TableSLBCopy.dnsName = this.selection[i].dnsName;
        TableSLBCopy.state = this.selection[i].state;
        TableSLBCopy.vpcId = this.selection[i].vpcId;
        TableSLBCopy.loadbalancerType = this.selection[i].loadbalancerType;
        TableSLBCopy.region = this.selection[i].region;
        TableSLBCopy.loadBalancerArn = this.selection[i].loadBalancerArn;
        this.newTableSlbDateList.push(TableSLBCopy);
      }
      if (this.selection.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 创建添加或编辑报警
    /**********************************************************************************/
    ok: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var alertList = {
            alertRuleName: this.slbWarningForm.ruleName,
            monitorIndex: this.slbWarningForm.monitorIndex,
            cycle: this.slbWarningForm.cycle,
            continousCycle: this.slbWarningForm.continousCycle,
            statisticsValue: this.slbWarningForm.statisticsValue,
            relationshipSign: this.slbWarningForm.relationshipSign,
            thresholdValue: this.slbWarningForm.thresholdValue,
            accountId: this.slbWarningForm.account,
            monitorModule: this.monitorModule,
            loadbalancerType: this.slbWarningForm.loadbalancerType,
            noticeType: this.slbWarningForm.noticeType,
            unit: this.units,
            regions: this.slbWarningForm.backupRegion,
            delay: this.slbWarningForm.alarmDelay,
            monitorPeriod: this.slbWarningForm.monitorPeriod,
            contactType: this.slbWarningForm.contactType,
            enterpriseWechatRobotIds:
              this.slbWarningForm.enterpriseWechatRobotIds,
          };

          // 如果联系方式是联系人 传通知对象
          if (this.slbWarningForm.contactType == 0) {
            alertList.contactIDs = this.slbWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.slbWarningForm.contactType == 1) {
            alertList.contactGroupIds = this.slbWarningForm.contactGroupIds;
          }

          // 如果监控指标为 负载均衡未关联实例 传审批流
          if (this.slbWarningForm.monitorIndex == 35) {
            alertList.processTemplateId = this.slbWarningForm.approvalFlow;
          }

          if (this.slbWarningForm.id > 0) {
            alertList.id = this.slbWarningForm.id;
            alertList.loadBalancerDTOList = this.newTableSlbDateList;
            // 编辑告警
            this.addloading = true;
            tableSlbWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.slbWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("编辑成功");
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowSearch = false;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addloading = true;
            alertList.loadBalancerDTOList = this.newTableSlbDateList;
            tableSlbWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  tableSlb.methods.showAll();
                  this.slbWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("添加成功");
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.isShowSearch = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.slbWarningForm.id > 0) {
            this.$Message.error("编辑失败");
          } else {
            this.$Message.error("添加失败");
          }
        }
      });
    },
    // 取消
    cancel: function (name) {
      this.wechatWarningVisible = false;
      this.isAddOrEdit = true;
      this.isShowSearch = false;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.isNextClick = true;
      this.modal = false;
      this.$emit("on-cancel");
      this.slbWarningForm.notificationObject = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      // 清空表格
      this.tableSlbDate = [];
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/slb/AddOrUpdateSlbWarning.vue